import {Outlet} from 'react-router-dom';

function TravelInsurances() {
  // const plans = useAppSelector(state => state.alliaznInsurance.plans);
  // const navigate = useNavigate()
  // React.useEffect(()=>{
  //   if (plans.length === 0){
  //     navigate('../')
  //   }
  // },[plans]); commented for dev purpose
  return <Outlet />;
}

export {TravelInsurances};
